// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dropZone__Zztzs {
  width: 100%;
  min-height: 200px;
  border: 2px dashed var(--color-blue-light);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  transition: all 0.2s ease;
  cursor: pointer;
  gap: 16px;
}
.styles_dropZone--dragOver__hcWTo {
  border-color: var(--color-accent-blue);
  background-color: var(--color-bg-light-blue);
}
.styles_dropZone__Zztzs:hover {
  background-color: var(--color-bg-light-blue);
}

.styles_dropZoneText__i7qoL {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
  text-align: center;
  margin: 0 0 16px;
}

.styles_attachButton__dhLuJ {
  margin-bottom: 0;
}

.styles_buttonIconImg__vwJbr {
  width: 16px;
  height: 16px;
}

.styles_selectedFiles__gEJZ6 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}
.styles_selectedFiles__gEJZ6::-webkit-scrollbar {
  display: none;
}
@media (min-width: 768px) {
  .styles_selectedFiles__gEJZ6 {
    flex-wrap: wrap;
    overflow-x: visible;
  }
}

.styles_fileTag__eyudU {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--color-blue-light);
  border-radius: 20px;
  font: var(--typography-body-s-medium);
  color: var(--color-black);
  max-width: 200px;
}

.styles_fileName__YWmkj {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_removeFileBtn__nrwG7 {
  background: none;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.styles_hiddenFileInput__zKp3l {
  display: none;
}

.styles_tourInfoButton__7doBt {
  align-self: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  color: var(--color-text-secondary);
}
.styles_tourInfoButton__7doBt:hover {
  background-color: var(--color-bg-light-blue);
  color: var(--color-accent-blue);
}
.styles_tourInfoButton__7doBt:active {
  transform: scale(0.95);
}

.styles_infoIcon__-tlPy {
  width: 24px;
  height: 24px;
  display: block;
  color: inherit;
}

@media (max-width: 768px) {
  .styles_dropZone__Zztzs {
    padding: 24px 16px;
    min-height: 180px;
    gap: 12px;
  }
  .styles_dropZoneText__i7qoL {
    font-size: 14px;
    margin: 0 0 8px;
    padding: 0 8px;
  }
  .styles_selectedFiles__gEJZ6 {
    grid-template-columns: 1fr;
    gap: 12px;
    overflow-x: visible;
  }
  .styles_fileTag__eyudU {
    max-width: none;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/insert-syllabi/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AAAF;AAEE;EACE,sCAAA;EACA,4CAAA;AAAJ;AAGE;EACE,4CAAA;AADJ;;AAKA;EACE,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EAGA,qBAAA;AAJF;AAKE;EACE,aAAA;AAHJ;AC1CE;EDkCF;IAeI,eAAA;IACA,mBAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kCAAA;AAHF;AAKE;EACE,4CAAA;EACA,+BAAA;AAHJ;AAME;EACE,sBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AALF;;AASA;EACE;IACE,kBAAA;IACA,iBAAA;IACA,SAAA;EANF;EASA;IACE,eAAA;IACA,eAAA;IACA,cAAA;EAPF;EAUA;IACE,0BAAA;IACA,SAAA;IACA,mBAAA;EARF;EAWA;IACE,eAAA;IACA,WAAA;EATF;AACF","sourcesContent":["@import \"mixins\";\n.dropZone {\n  width: 100%;\n  min-height: 200px;\n  border: 2px dashed var(--color-blue-light);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  gap: 16px;\n\n  &--dragOver {\n    border-color: var(--color-accent-blue);\n    background-color: var(--color-bg-light-blue);\n  }\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n  }\n}\n\n.dropZoneText {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n  text-align: center;\n  margin: 0 0 16px;\n}\n\n.attachButton {\n  margin-bottom: 0;\n}\n\n.buttonIconImg {\n  width: 16px;\n  height: 16px;\n}\n\n.selectedFiles {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n  overflow-x: auto;  // Enable horizontal scrolling\n  padding-bottom: 8px;  // Space for scrollbar\n  \n  // Optional: Hide scrollbar but keep functionality\n  scrollbar-width: none;  // Firefox\n  &::-webkit-scrollbar {\n    display: none;  // Chrome, Safari\n  }\n\n  @include md {\n    flex-wrap: wrap;\n    overflow-x: visible;  // No scroll on desktop\n  }\n}\n\n.fileTag {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-blue-light);\n  border-radius: 20px;\n  font: var(--typography-body-s-medium);\n  color: var(--color-black);\n  max-width: 200px;\n}\n\n.fileName {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.removeFileBtn {\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.hiddenFileInput {\n  display: none;\n}\n\n.tourInfoButton {\n  align-self: flex-end;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  color: var(--color-text-secondary);\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n    color: var(--color-accent-blue);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.infoIcon {\n  width: 24px;\n  height: 24px;\n  display: block;\n  color: inherit;\n}\n\n// Mobile responsive styles\n@media (max-width: 768px) {\n  .dropZone {\n    padding: 24px 16px;\n    min-height: 180px;\n    gap: 12px;\n  }\n\n  .dropZoneText {\n    font-size: 14px;\n    margin: 0 0 8px;\n    padding: 0 8px;\n  }\n\n  .selectedFiles {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    overflow-x: visible;\n  }\n\n  .fileTag {\n    max-width: none;\n    width: 100%;\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropZone": `styles_dropZone__Zztzs`,
	"dropZone--dragOver": `styles_dropZone--dragOver__hcWTo`,
	"dropZoneText": `styles_dropZoneText__i7qoL`,
	"attachButton": `styles_attachButton__dhLuJ`,
	"buttonIconImg": `styles_buttonIconImg__vwJbr`,
	"selectedFiles": `styles_selectedFiles__gEJZ6`,
	"fileTag": `styles_fileTag__eyudU`,
	"fileName": `styles_fileName__YWmkj`,
	"removeFileBtn": `styles_removeFileBtn__nrwG7`,
	"hiddenFileInput": `styles_hiddenFileInput__zKp3l`,
	"tourInfoButton": `styles_tourInfoButton__7doBt`,
	"infoIcon": `styles_infoIcon__-tlPy`
};
export default ___CSS_LOADER_EXPORT___;
